export const locationIndexHeaders = [
  {
    text: "State",
    value: "state"
  },
  {
    text: "City",
    value: "name"
  },
  {
    text: "Page Title",
    value: "meta_title"
  },
  {
    text: "Last Update",
    value: "updated_at"
  },
  {
    text: "Published",
    value: "published"

  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];
